<template>
    <v-app
        class="app-top"
        :class="{ 'is-routing': isRouting, 'is-landscape': landscape }"
    >
        <div class="fixed-iphonex-top blue"></div>
        <v-progress-linear
            indeterminate
            color="pink"
            v-show="pageLoading"
        ></v-progress-linear>
        <v-content>
            <v-slide-x-reverse-transition hide-on-leave>
                <router-view></router-view>
            </v-slide-x-reverse-transition>
        </v-content>
    </v-app>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "App",
    computed: {
        ...mapState([
            "isRouting",
            "pageLoading",
            "landscape",
            "isKeyboardOpen"
        ]),
        appClass() {
            return this.isRouting ? "is-routing" : "";
        }
    },
    watch: {
        isKeyboardOpen(val) {
            if (!val) {
                window.scrollTo(0, 99999);
            }
        }
    }
};
</script>
<style lang="scss">
body {
    width: 100vw;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    padding-left: constant(safe-area-inset-left);
    padding-left: env(safe-area-inset-left);
    padding-right: constant(safe-area-inset-right);
    padding-right: env(safe-area-inset-right);
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    .theme--light.application {
        background: #fff;
    }
    .fixed-iphonex-top {
        height: calc(56px + constant(safe-area-inset-top));
        height: calc(56px + env(safe-area-inset-top));
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 8;
    }
    .is-landscape {
        .fixed-iphonex-top {
            height: calc(48px + constant(safe-area-inset-top));
            height: calc(48px + env(safe-area-inset-top));
        }
    }
}
.v-toolbar--fixed {
    z-index: 9;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 10px 10px 0px rgba(0, 0, 0, 0.12);
    transition: none !important;
    top: constant(safe-area-inset-top) !important;
    top: env(safe-area-inset-top) !important;
    .v-toolbar__content {
        padding-left: calc(16px + constant(safe-area-inset-left));
        padding-left: calc(16px + env(safe-area-inset-left));
        padding-right: calc(16px + constant(safe-area-inset-right));
        padding-right: calc(16px + env(safe-area-inset-right));
    }
}

.is-routing {
    .v-toolbar--fixed {
        position: absolute !important;
        top: calc(-56px + constant(safe-area-inset-top)) !important;
        top: calc(-56px + env(safe-area-inset-top)) !important;
    }
    &.is-landscape {
        .v-toolbar--fixed {
            top: calc(-48px + constant(safe-area-inset-top)) !important;
            top: calc(-48px + env(safe-area-inset-top)) !important;
        }
    }
}
.v-progress-linear {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 299;
    height: 3px !important;
    margin: 0;
}
.btn-h48 {
    height: 48px;
}
.application--is-rtl {
    .v-form {
        .ma-0.right.v-btn.primary--text {
            float: left !important;
        }
    }
}
</style>
